import TaskTimeline from "@/components/TaskTimeline";
import { useAuth } from "@/context/AuthContext";

export default function TimelinePage() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 p-4" data-testid="timeline-page">
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono-num mb-2 px-1">
        Crew Ready — live timeline window
      </div>
      <TaskTimeline userId={user.id} companyId={user.company_id} locationId={user.location_id}
        tasksLabel={user?.terminology?.task_label_plural || "Tasks"} />
    </div>
  );
}
